import request from '@/utils/request'
import { getExel } from '@/utils/exportExcal'
export function integrationOrderDetail(params) {
  return request({
    url: '/order/detail/'+params.orderId,
    method: 'get',
    // params: params
    // data: params
  })
}export function integrationJournalTotal(params) {
  return request({
    url: '/member/integrationJournal/integration',
    method: 'get',
    params: params
    // data: params
  })
}
export function logistics(params) {
  return request({
    url: '/order/logistics',
    method: 'post',
    data: params
  })
}
export function integrationExport2(params) {
  return  getExel('member/integrationJournal/export',params,'get')

}
export function integrationPage2(params) {
  return request({
    url: '/member/integrationJournal/page',
    method: 'get',
    params: params
  })
}
export function integration(params) {
  return request({
    url: '/member/integrationSource/integration',
    method: 'get',
    params: params
    // data: params
  })
}
export function integrationExport(params) {
  return getExel('member/integrationSource/export',params,'get')
}
export function integrationPage(params) {
  return request({
    url: '/member/integrationSource/page',
    method: 'get',
    params: params
  })
}
/**
文件上传
  **/
export function upload(params) {
  return request({
    url: '/minio/upload',
    method: 'post',
    data: params
  })
}
/**
 *在线商城申请
 * **/
//查询门店
export function currentMall(params) {
  return request({
    url: '/store/current',
    method: 'get',
    params: params
  })
}

//商城申请
export function applyMall(params) {
  return request({
    url: '/store/mall-apply',
    method: 'post',
    data: params
  })
}
//商城申请
export function quitOnlineStore(params) {
  return request({
    url: '/store/QuitOnlineStore',
    method: 'post',
    data: params
  })
}

/**
 *在线商城服务
 * **/
//查询服务分类
export function productCategory(params) {
  return request({
    url: '/productCategory/categoryList',
    method: 'get',
    params: params
  })
}

//服务分类上架
export function sortUp(params) {
  return request({
    url: '/productCategory/up/changeStatus',
    method: 'post',
    data: params
  })
}

//服务分类下架
export function sortDown(params) {
  return request({
    url: '/productCategory/down/changeStatus',
    method: 'post',
    data: params
  })
}

/**
 *服务/商品服务
 * **/
//服务/商品查询
export function productList(params) {
  return request({
    url: '/product/list',
    method: 'get',
    params: params
  })
}
export function productList2(params) {
  return request({
    url: '/product/productList',
    method: 'get',
    params: params
  })
}
//服务/商品价格修改
export function updatePrice(params) {
  return request({
    url: '/product/updatePrice',
    method: 'post',
    data: params
  })
}
/**
 * 商品品牌获取
 * @returns {Promise}
 */
export function queryBrand() {
  return request({
    url: '/product/queryBrand',
    method: 'post',
    data: {}
  })
}
//服务分类上架
export function productUp2(params) {
  return request({
    url: '/product/up/batchUpdateStatus',
    method: 'post',
    data: params
  })
}
export function productUp(params) {
  return request({
    url: '/product/productUp',
    method: 'post',
    data: params
  })
}
export function productUpdate(params) {
  return request({
    url: '/product/update',
    method: 'post',
    data: params
  })
}export function productAdd(params) {
  return request({
    url: '/product/add',
    method: 'post',
    data: params
  })
}

export function categoryList(params) {
  return request({
    url: '/productCategory/categoryList',
    method: 'get',
    params: params
  })
}
//服务分类下架
export function productDown(params) {
  return request({
    url: '/product/productDown',
    method: 'post',
    data: params
  })
}

//服务分类下架
export function productDown2(params) {
  return request({
    url: '/product/down/batchUpdateStatus',
    method: 'post',
    data: params
  })
}

/**
 *限时抢购
 * **/
//活动列表
export function getListActivity(params) {
  return request({
    url: '/activity/page',
    method: 'post',
    data: params
  })
}

//活动新增
export function createActivity(params) {
  return request({
    url: '/activity/create',
    method: 'post',
    data: params
  })
}
//活动修改
export function modifyActivity(params) {
  return request({
    url: '/activity/modify',
    method: 'post',
    data: params
  })
}
//活动详情
export function detailActivity(params) {
  return request({
    url: '/activity/detail',
    method: 'post',
    data: params
  })
}
//活动详情
export function deleteActivity(params) {
  return request({
    url: '/activity/delete',
    method: 'post',
    data: params
  })
}

//活动置顶
export function activitySort(params) {
  return request({
    url: '/activity/sort',
    method: 'post',
    data: params
  })
}
//活动下架
export function downActivity(params) {
  return request({
    url: '/activity/down/batchUpdateStatus',
    method: 'post',
    data: params
  })
}
//活动上架
export function upActivity(params) {
  return request({
    url: '/activity/up/batchUpdateStatus',
    method: 'post',
    data: params
  })
}
/**
 *优惠券
 * **/
//优惠券列表
export function queryCouponList(params) {
  return request({
    url: '/couponManage/queryCouponList',
    method: 'post',
    data: params
  })
}

//新增优惠券
export function createCoupon(params) {
  return request({
    url: '/couponManage/createCoupon',
    method: 'post',
    data: params
  })
}
//修改优惠券
export function modifyCoupon(params) {
  return request({
    url: '/couponManage/modifyCouponInfo',
    method: 'post',
    data: params
  })
}

//优惠券详情
export function queryCouponDetail(params) {
  return request({
    url: '/couponManage/queryCouponDetail',
    method: 'post',
    data: params
  })
}
//优惠券启用
export function enableCoupon(params) {
  return request({
    url: '/couponManage/enable',
    method: 'post',
    data: params
  })
}
//优惠券停用
export function disableCoupon(params) {
  return request({
    url: '/couponManage/disable',
    method: 'post',
    data: params
  })
}
//优惠券使用情况
export function queryUsePage(params) {
  return request({
    url: '/couponStatistics/queryUsePage',
    method: 'post',
    data: params
  })
}
/**
 *商品活动订单
 * **/
export function orderDetail(params) {
  return request({
    url: '/order/detail',
    method: 'GET',
    params: params
  })
}
export function orderVerification(params) {
  return request({
    url: '/order/verification',
    method: 'POST',
    data: params
  })
}
export function orderList(params) {
  return request({
    url: '/order/list',
    method: 'post',
    data: params
  })
} export function prodOrderList(params) {
  return request({
    url: '/order/prodOrderList  ',
    method: 'post',
    data: params
  })
}
export function orderRefund(params) {
  return request({
    url: '/orderRefund/list',
    method: 'post',
    data: params
  })
}
export function orderRefundRelease(params) {
  return request({
    url: '/orderRefund/release',
    method: 'post',
    data: params
  })
}
export function orderRefundReject(params) {
  return request({
    url: '/orderRefund/reject',
    method: 'post',
    data: params
  })
}
/**
 *评价
 * **/
//评价列表
export function commentList(params) {
  return request({
    url: '/comment/list',
    method: 'get',
    params: params
  })
}

export function checkAccount(params) {
  return request({
    url: '/report/storeBill',
    method: 'get',
    params: params
  })
}

// 用户金币余额查询
export function memberIntegrationPage(params) {
  return request({
    url: '/member/integrationJournal/info/page',
    method: 'get',
    params: params
  })
}
// 用户金币余额导出
export function memberIntegrationExport(params) {
  return getExel('member/integrationJournal/info/export',params,'get')
}
// 订单管理导出
export function orderExport(params) {
  return getExel('order/export',params,'POST')
}
// 订单管理导入
export function orderTemplateUpload(params) {
  return request({
    url: '/order/upload',
    method: 'POST',
    data: params
  }) ;
}
// 商品日志管理
export function proHistoryPage(params) {
  return request({
    url: '/product/history/page',
    method: 'get',
    params: params
  }) ;
}
// 订单管理导出
export function proHistoryExport(params) {
  return getExel('product/history/export',params,'POST')
}
// 商品管理导入
export function proTemplateUpload(params) {
  return request({
    url: '/product/upload',
    method: 'POST',
    data: params
  }) ;
}
// 商品管理导出
export function proExport(params) {
  return getExel('product/listExport',params,'POST')
}
// 金币类型
export function getIntegrationStatusList() {
  return request({
    url: '/setting/getIntegrationSourceType',
    method: 'get'
  }) ;
}
//------------------------------------------------ 系统参数配置
/**
 * 获取兑换金币上限值
 * @returns 
 */
export function getIntegrationUpperLimit() {
  return request({
    url: '/setting/integration/upperLimit',
    method: 'get'
  });
}
/**
 * 设置金币兑换上限
 * @returns 
 */
export function setUpperLimit(params) {
  return request({
    url: '/setting/integration/setUpperLimit',
    method: 'POST',
    data: params
  });
}


// WEBPACK FOOTER //
// ./src/api/mall.js